module.exports = __webpack_public_path__ + "img/fastvaluedeal-card-step.a689da55.png";